import React from "react";
import { Box, CircularProgress } from "@mui/material";
import BookingGetters from "../../store/onlineBooking/getters";

type CardWithLoaderProps = {
  isLoading: boolean;
  children?: React.ReactNode;
};

const CardWithLoader: React.FC<CardWithLoaderProps> = ({
  isLoading,
  children,
}) => {
  const appSettings = BookingGetters.getAppSettings();
  const webCheckinHeaderBgColor = appSettings?.webCheckinHeaderBgColor;
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {children}

      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backdropFilter: "blur(3px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            borderRadius: "12px",
          }}
        >
          <CircularProgress
            color="success"
            size={50}
            thickness={3}
            sx={{
              color: webCheckinHeaderBgColor || "#2cb133",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default CardWithLoader;
